var ReadRecoveryCodesModule = /** @class */ (function () {
    function ReadRecoveryCodesModule() {
    }
    return ReadRecoveryCodesModule;
}());
export { ReadRecoveryCodesModule };
